var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      key: "4",
      staticClass: "text-center",
      attrs: { top: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "ma-0 pa-0 btnCanvas",
                      staticStyle: {
                        background: "transparent !important",
                        "pointer-events": "all",
                      },
                      attrs: {
                        rounded: "",
                        elevation: "0",
                        regular: "",
                        disabled: !_vm.configurationComplete,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.snap()
                        },
                      },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-icon",
                    { attrs: { large: "", dark: "", color: "primary" } },
                    [_vm._v("print")]
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [_vm._v(" Print ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }